var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.isLink ? 'router-link' : 'button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    tag: "component",
    class: {
      'link': _vm.isLink,
      'sheet-icon-wrapper': true
    },
    attrs: {
      "type": _vm.isLink ? undefined : 'button',
      "target": _vm.isLink ? '_blank' : undefined,
      "title": _vm.$t(_vm.tooltipKey),
      "aria-label": _vm.$t(_vm.tooltipKey),
      "to": _vm.isLink ? _vm.sheetRoute : undefined
    },
    on: {
      "touchstart": _vm.startLongPress,
      "touchend": _vm.onTouchEnd,
      "touchmove": _vm.onTouchMove,
      "touchcancel": _vm.cancelTouch,
      "click": _vm.handleClick
    }
  }, [_c('b-icon', {
    staticClass: "h3 mx-1",
    attrs: {
      "icon": _vm.icon,
      "aria-hidden": "true"
    }
  }), _vm.isTooltipVisible ? _c('span', {
    staticClass: "mobile-sheet-tooltip",
    attrs: {
      "role": "tooltip"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.tooltipKey)) + " ")]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }